module.exports = __webpack_public_path__ + "static/media/bg_image_1.1422f39a.jpg";